import React, { Component } from 'react';
import { Row, Col, Avatar, Input, Skeleton } from 'antd';
import Button from '../common/atoms/DSButton';
import HelpApi from '../../services/help.api';
import profile_avatar from '../../assets/images/profile_avatar.svg';
import mailIcon from '../../assets/images/email.svg';
import phoneIcon from '../../assets/images/phone.svg';
import handleAppError from '../handlers/handleAppError';
import { successOrFailureToaster } from '../common/atoms/messages';
import xmarkIcon from '../../assets/images/closered.svg';
import green_tick from '../../assets/images/green_tick.svg';

const helpTopicButtonBaseClass =
  'mb-2 mr-1.5 inline-flex h-10 items-center justify-center rounded-ds-md border border-gray-300 bg-white px-5 text-xs font-semibold leading-none text-gray-700 shadow-ds-sm transition hover:border-gray-400 hover:bg-gray-100 hover:text-gray-900';
const helpTopicButtonActiveClass =
  'border-ds-brand bg-ds-brand text-white shadow-ds-sm hover:border-ds-brand-dk hover:bg-ds-brand-dk hover:text-white';
const helpSubmitButtonClass =
  'mt-4 inline-flex h-11 min-w-max items-center justify-center rounded-ds-md border border-ds-brand bg-ds-brand px-5 text-xs font-semibold leading-none text-white shadow-ds-sm transition hover:border-ds-brand-dk hover:bg-ds-brand-dk focus:outline-none';

class HelpDrawerBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedHelpkey: '',
      description: '',
      setInitialKey: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { initialKey } = nextProps;
    if (nextProps.reset) {
      this.setState({ selectedHelpkey: null, description: '', setInitialKey: false });
    } else if (!this.state.setInitialKey && initialKey) {
      this.setState({ selectedHelpkey: initialKey, setInitialKey: true });
    }
  }

  submitHelpRequest = () => {
    if (this.state.description.trim() === '' || this.state.selectedHelpkey === null) {
      successOrFailureToaster({ message: 'No topic selected or the description is empty', type: 'fail' })
      return
    }

    const options = {
      data: {
        service_type: this.state.selectedHelpkey,
        description: this.state.description,
      },
    };

    HelpApi.help_submit(
      options,
      () => {
        this.setState({ selectedHelpkey: null, description: '' });

        successOrFailureToaster({ message: 'Request has been submitted' })
      },
      (error) => handleAppError(error)
    );
  };

  selectService = (event) => {
    this.setState({ selectedHelpkey: event.currentTarget.id });
  };

  render() {
    const { name, email, mobile } = this.props.data;
    return this.props.data === null ? (
      <div>
        <Skeleton active paragraph={{ rows: 4 }} />
        <Skeleton active paragraph={{ rows: 4 }} />
        <Skeleton active paragraph={{ rows: 4 }} />
      </div>
    ) : (
      <div style={{ marginBottom: '13px', overflow: 'auto' }}>
        <p className='help-know-your-customer'>Know your customer success manager</p>
        <p className='help-you-can-reach'>
          You can reach out to your customer success manager at any time on the below details
        </p>
        <Row className='help-profile-row'>
          <Col span={4}>
            <Avatar
              src={profile_avatar}
              alt='profile-avatar'
              shape='circle'
              style={{ height: '48px', width: '48px' }}
            />
          </Col>
          <Col span={20}>
            <p className='help-profile-name'>{name}</p>
            <p className='help-profile-role'>Customer Success Manager</p>

            <div className='help-profile-row-mail_phone'>
              <div style={{ display: 'flex', margin: '0px 10px 7px 0px' }}>
                <img src={mailIcon} alt='mailIcon' className='help-mail-phone-img' />
                <div style={{ overflowWrap: 'anywhere' }}>{email}</div>
              </div>

              {mobile && (
                <div style={{ display: 'flex' }}>
                  <img src={phoneIcon} alt='phoneIcon' className='help-mail-phone-img' />
                  <div>{`+91 ${mobile}`}</div>
                </div>
              )}
            </div>
          </Col>
        </Row>

        <p className='help-select-topic'>Select a topic</p>
        <p className='help-if-you-have-query'>
          If you have a query, select the appropriate section from the below options and send us the request. Your
          customer success manager will respond back to you within 4 hours.
        </p>
        <div style={{ marginBottom: '22px' }}>
          {Object.values(this.props.data.services_offered).map((value) => {
            const buttonId = value.replace(/ /g, '_');
            return (
              <Button
                className={`${helpTopicButtonBaseClass} ${this.state.selectedHelpkey === buttonId ? helpTopicButtonActiveClass : ''}`}
                id={buttonId}
                key={buttonId}
                onClick={this.selectService}
              >
                {value}
              </Button>
            );
          })}
          <Button
            className={`${helpTopicButtonBaseClass} ${this.state.selectedHelpkey === 'others' ? helpTopicButtonActiveClass : ''}`}
            id='others'
            key='others'
            onClick={this.selectService}
          >
            Others
          </Button>
        </div>
        <p className='help-write-here'>Write here</p>
        <Input.TextArea
          placeholder='Enter a topic. Eg: Notifications'
          className='help-textarea-xs'
          value={this.state.description}
          onChange={(event) => {
            this.setState({ description: event.target.value });
          }}
        ></Input.TextArea>
        <Button className={helpSubmitButtonClass} style={{ float: 'right' }} onClick={this.submitHelpRequest}>
          Submit
        </Button>
      </div>
    );
  }
}

export default HelpDrawerBody;
